/**
 * Sticky add-to-cart: scroll visibility, triggers main PDP add button, syncs price + size pickers with `variant-selects`.
 */
(function () {
  function getProductInfo() {
    return document.querySelector('product-info');
  }

  function getMainAddButton() {
    const pi = getProductInfo();
    if (!pi) return null;
    return pi.querySelector('product-form [name="add"][type="submit"]');
  }

  function getVariantSelects(productInfo) {
    return productInfo ? productInfo.querySelector('variant-selects') : null;
  }

  function readMainOptionValue(vs, optionName) {
    if (!vs || !optionName) return '';
    const optKey = 'options[' + optionName + ']';
    const selects = vs.querySelectorAll('select');
    for (let i = 0; i < selects.length; i++) {
      if (selects[i].name === optKey) return selects[i].value;
    }
    const esc =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? function (s) {
            return CSS.escape(String(s));
          }
        : function (s) {
            return String(s).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
          };
    const checked = vs.querySelector('input[type="radio"][name="' + esc(optionName) + '"]:checked');
    return checked ? checked.value : '';
  }

  function applyMainOptionValue(productInfo, optionName, value) {
    const vs = getVariantSelects(productInfo);
    if (!vs || !optionName || value == null) return false;
    const optKey = 'options[' + optionName + ']';
    const selects = vs.querySelectorAll('select');
    for (let i = 0; i < selects.length; i++) {
      const sel = selects[i];
      if (sel.name !== optKey) continue;
      const match = Array.from(sel.options).find(function (o) {
        return o.value === value && !o.disabled;
      });
      if (!match) return false;
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    const esc =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? function (s) {
            return CSS.escape(String(s));
          }
        : function (s) {
            return String(s).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
          };
    const radios = vs.querySelectorAll('input[type="radio"][name="' + esc(optionName) + '"]');
    for (let j = 0; j < radios.length; j++) {
      const r = radios[j];
      if (r.value === value && !r.disabled) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function syncStickySizeSelects(root, productInfo, optionName) {
    if (!optionName) return;
    const vs = getVariantSelects(productInfo);
    const v = readMainOptionValue(vs, optionName);
    if (!v) return;
    root.querySelectorAll('[data-sticky-size-select]').forEach(function (sel) {
      if (Array.from(sel.options).some(function (o) {
        return o.value === v && !o.disabled;
      })) {
        sel.value = v;
      }
    });
  }

  function wireSizeSelects(root, productInfo, productSectionId, optionName, syncFromMain) {
    const selects = root.querySelectorAll('[data-sticky-size-select]');
    if (!selects.length || !optionName) return;
    let lock = false;
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (lock) return;
        lock = true;
        const val = sel.value;
        selects.forEach(function (s) {
          if (s !== sel) s.value = val;
        });
        lock = false;
        applyMainOptionValue(productInfo, optionName, val);
        requestAnimationFrame(syncFromMain);
      });
    });
  }

  function getMoneyFormat(root, productInfo) {
    const vs = getVariantSelects(productInfo);
    return (
      (vs && vs.getAttribute('data-glacier-money-format')) ||
      root.getAttribute('data-money-format') ||
      '${{amount}}'
    );
  }

  function formatMoney(cents, moneyFormat) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    const amount = (Math.abs(cents) / 100).toFixed(2);
    const amountNoDecimals = Math.round(Math.abs(cents) / 100).toString();
    const withComma = amount.replace('.', ',');
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function getVariantData(productInfo) {
    const vs = getVariantSelects(productInfo);
    if (!vs) return [];
    const script = vs.querySelector('script[type="application/json"]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function getCurrentVariantId(productInfo, productSectionId) {
    if (!productSectionId) return null;
    const form = document.getElementById('product-form-' + productSectionId);
    const input = form ? form.querySelector('input[name="id"]') : null;
    return input ? input.value : null;
  }

  function getCurrentVariant(productInfo, productSectionId) {
    const variantId = getCurrentVariantId(productInfo, productSectionId);
    if (!variantId) return null;
    return getVariantData(productInfo).find(function (v) {
      return String(v.id) === String(variantId);
    });
  }

  function renderStickyPrice(priceTarget, variant, moneyFormat) {
    if (!priceTarget || !variant) return;
    const price = variant.price;
    const compareAt = variant.compare_at_price;
    const onSale = typeof compareAt === 'number' && compareAt > price;

    if (onSale) {
      priceTarget.innerHTML =
        '<div class="gs-sticky-atc__price-sale">' +
        formatMoney(price, moneyFormat) +
        '</div>' +
        '<div class="gs-sticky-atc__price-regular">' +
        formatMoney(compareAt, moneyFormat) +
        '</div>';
    } else {
      priceTarget.innerHTML =
        '<div class="gs-sticky-atc__price-sale">' + formatMoney(price, moneyFormat) + '</div>';
    }
  }

  function updateThumb(root, variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src) return;
    const img = root.querySelector('.gs-sticky-atc__thumb img');
    if (!img) return;
    var u = variant.featured_image.src;
    if (u.indexOf('?') === -1) u += '?width=200';
    else u += '&width=200';
    img.src = u;
  }

  function initOne(root) {
    if (!root || root.dataset.stickyAtcInit === '1') return;
    root.dataset.stickyAtcInit = '1';

    const trigger = root.querySelector('[data-sticky-atc-trigger]');
    const priceTarget = root.querySelector('[data-sticky-atc-price]');
    const threshold = parseInt(String(root.dataset.stickyScrollThreshold || '0'), 10) || 0;
    const scrollMode = root.dataset.stickyShowMode === 'scroll';
    const sizeOptionName = root.getAttribute('data-sticky-size-option-name') || '';
    const productInfo = getProductInfo();
    const productSectionId = productInfo ? productInfo.dataset.section : null;
    const moneyFormat = getMoneyFormat(root, productInfo);

    function setBarVisible(visible) {
      root.classList.toggle('gs-sticky-atc--visible', visible);
    }

    function syncFromMain(variant) {
      const activeVariant = variant || getCurrentVariant(productInfo, productSectionId);
      if (priceTarget && activeVariant) {
        renderStickyPrice(priceTarget, activeVariant, moneyFormat);
      }
      const mainBtn = getMainAddButton();
      if (mainBtn && trigger) {
        const disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
        trigger.disabled = disabled;
        trigger.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        const span = mainBtn.querySelector('span');
        const tspan = trigger.querySelector('span');
        if (span && tspan) {
          tspan.textContent = span.textContent;
        } else {
          trigger.textContent = mainBtn.textContent;
        }
      } else if (!mainBtn && trigger) {
        trigger.disabled = true;
        trigger.setAttribute('aria-disabled', 'true');
      }
      if (productInfo && sizeOptionName) {
        syncStickySizeSelects(root, productInfo, sizeOptionName);
      }
    }

    if (scrollMode) {
      if (threshold <= 0) {
        setBarVisible(true);
      } else {
        function onScroll() {
          var y = window.scrollY || document.documentElement.scrollTop;
          setBarVisible(y >= threshold);
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    } else {
      setBarVisible(true);
    }

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const main = getMainAddButton();
        if (main && !main.disabled && main.getAttribute('aria-disabled') !== 'true') {
          main.click();
        }
      });
    }

    if (productInfo && sizeOptionName) {
      syncStickySizeSelects(root, productInfo, sizeOptionName);
      wireSizeSelects(root, productInfo, productSectionId, sizeOptionName, syncFromMain);
    }

    if (productSectionId && getMainAddButton()) {
      syncFromMain();
      const mo = new MutationObserver(function () {
        syncFromMain();
      });
      const formEl = getMainAddButton() ? getMainAddButton().closest('product-form') : null;
      if (formEl) {
        mo.observe(formEl, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
        });
        const variantInput = formEl.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.addEventListener('change', function () {
            requestAnimationFrame(syncFromMain);
          });
        }
      }
    } else if (priceTarget) {
      syncFromMain();
    }

    const variantSelects = getVariantSelects(productInfo);
    if (variantSelects) {
      variantSelects.addEventListener('change', function () {
        requestAnimationFrame(function () {
          syncFromMain();
        });
      });
    }

    function onVariantChange(event) {
      if (!event || !event.data || !productSectionId) return;
      if (String(event.data.sectionId) !== String(productSectionId)) return;
      if (event.data.variant) {
        updateThumb(root, event.data.variant);
        syncFromMain(event.data.variant);
      } else {
        requestAnimationFrame(syncFromMain);
      }
    }

    var subAttempts = 0;
    function bindVariantSubscribe() {
      const variantChangeEvent =
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange
          ? PUB_SUB_EVENTS.variantChange
          : 'variant-change';
      if (typeof subscribe === 'function') {
        subscribe(variantChangeEvent, onVariantChange);
        return;
      }
      if (subAttempts++ < 40) setTimeout(bindVariantSubscribe, 50);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindVariantSubscribe);
    } else {
      bindVariantSubscribe();
    }
  }

  function init() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
